module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Regular-ea364284.woff2";